export default function useSystemMessages() {
  /********************
   * COMPOSITIONS      *
   ********************/
  const { $gettext, interpolate } = useGettext();

  /********************
   * FUNCTIONS         *
   ********************/
  function getMsgError(errorCode, additionalInfo = null) {
    const messages = {
      reviews_multiple_not_allowed: $gettext('We are sorry but you are not allowed to submit more than one review.'),
      reviews_multiple_per_year_not_allowed: $gettext(
        'We are sorry but you are not allowed to submit more than one review per year.',
      ),
      required: $gettext('This field is required'),
    };

    if (additionalInfo && messages[errorCode]) {
      return interpolate(messages[errorCode], { additionalInfo }, true);
    }

    return messages[errorCode] ? messages[errorCode] : $gettext('An unkown error occured. Please try again.');
  }

  function getMsgWarning(warningCode) {
    const messages = {
      email_not_verified: $gettext(
        'Your email address has not been verified yet. We have sent you a new verification email. To publish your reviews, pictures and videos you need to verify your account first.',
      ),
    };

    return messages[warningCode] ? messages[warningCode] : $gettext('An unkown warning occured. Please try again.');
  }
  return {
    getMsgError,
    getMsgWarning,
  };
}
